import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalLocation from '../shared/components/modal-location/modal-location.view.html';
import modalSelectClient from '../shared/components/modal-select-client/modal-select-client.view.html';
import modalSelectBranch from '../login/modal-select-branch-b2b-user/modal-select-branch-b2b-user.view.html';
import createPQRSModal from '../pqrs/pqrs-form-modal/pqrs-form-modal.view.html';
import modalSelectModalidadPago from '../shared/components/modal-select-modalidad-pago/modal-select-modalidad-pago.view.html';

let inject = [
    '$scope',
    '$state',
    '$window',
    'SharedService',
    'CartService',
    '$rootScope',
    '$uibModal',
    'AuthTokenFactory',
    'ngAuthSettings',
    '$templateCache',
    '$location',
    '$timeout',
    'SessionService',
    'userData',
    'LoginService',
    '$compile',
    '$interval'
];

class SharedController {
    constructor($scope,
        $state,
        $window,
        SharedService,
        CartService,
        $rootScope,
        $uibModal,
        AuthTokenFactory,
        ngAuthSettings,
        $templateCache,
        $location,
        $timeout,
        SessionService,
        userData,
        LoginService,
        $compile,
        $interval) {

        this.$interval = $interval;
        this.$state = $state;
        this.LoginService = LoginService;
        this.SharedService = SharedService;
        this.CartService = CartService;
        this.SessionService = SessionService;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$templateCache = $templateCache;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$location = $location;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.$uibModal = $uibModal;
        this.$compile = $compile;
        this.clientSelected = {};
        this.formatDate = 'yyyy/MM/dd';
        this.dateOptions = {
            maxDate: new Date(2020, 5, 22),
            startingDay: 1,
            showWeeks: false,
        };
        this.altInputFormats = ['M!/d!/yyyy'];
        this.openModal = false;
        this.submittingCart = false;
        this.checkOrderAfterConect = false;
        this.isCheckingCart = false;
        this.globals = userData.globals;
        this.cart = userData.cartInfo;
        this.userData = userData;
        this.params = userData.params;
        this.globalCategoriesMenu = userData.categoriesMenu;
        this.globalBanners = userData.banners;
        this.globalCategories = userData.globalCategories;
        this.mensajeNotificacion = '';
        this.tituloMensajeNotificacion = '';
        this.newsletterDataForm = {};
        this.sendingNewsletterInfo = true;
        this.cookiesAccepted = false;
        this.newsletterInfoError = false;
        this.enteredCaptcha = false;
        this.expiredCaptcha = false;
        this.captchaId = null;
        this.captcha = '';
        this.searchProductsGlobal = [];
        this.newsletterInfoMessage = '';
        this.globalSearchTextHome = '';
        this.themeCaptcha = 'light';
        this.captchaKey = this.ngAuthSettings.config.captchaKey;

        this.hour = '00';
        this.minute = '00';
        this.second = '00';
        this.days = '0';

        this.clientLogo = "./assets/img/clients/" + __env.clientName + "/logo-header.png";

        this.activate();
        this.$scope.$on('onReloadPage', (event, arg) => {
            event.stopPropagation();
            this.activate();
            // console.log("hola");
        });

        this.$scope.$on('onUpdateCart', (event, arg) => {
            event.stopPropagation();
            this.updateCartInfo(arg);
        });

        this.$scope.$on('onShowModalErrorAddItem', (event, arg) => {
            event.stopPropagation();

        });

        this.$scope.$on('$viewContentLoaded', (event) => {
            event.stopPropagation();
            if (window.loading_screen !== null) {
                window.loading_screen.finish();
                window.loading_screen = null;
            }
        });

        let that = this;
        let authPages = ["home", "categories", "reportes"];

        this.$rootScope.$on('$locationChangeSuccess', function (event, next, current) {
            that.$window.ga('send', 'pageview', { page: that.$location.url() });
        });

        this.$rootScope.$on('$locationChangeSuccess', function (event, next, current) {
            // if(that.globals.currentUser){
            //     let term = that.$location.url();
            //     $.each(authPages, function (key, queryVal) {
            //         let searchPath = term.search(queryVal)
            //         if(searchPath > 0){
            //             // that.$state.go('home.landing');
            //             console.log(123)
            //         }
            //     });
            // }
        });

        // if (this.$state.current.name === 'home') {
        //     this.$state.go("home.home");
        // }
    }


    activate() {

        // let that = this;
        // let authPages = ["home","categories","reportes"];
        // if(this.globals.currentUser){
        //     let term = that.$location.url();
        //     $.each(authPages, function (key, queryVal) {
        //         let searchPath = term.search(queryVal)
        //         if(searchPath > 0){
        //             console.log(456)
        //             // window.location.href = "/#!/login";
        //         }
        //     });
        // }
        document.title = (this.ngAuthSettings.site.info.company.titlePage == null) ?
            this.ngAuthSettings.site.info.company.name : this.ngAuthSettings.site.info.company.titlePage;

        let favicon = document.getElementById('favicon');
        favicon.href = this.ngAuthSettings.site.info.company.favicon;

        this.getOfflinePage();
        this.SessionService.getGlobals().then(globals => {
            if (!this.globals.currentUser) {
                if (
                    this.$state.current.name !== 'home.login' &&
                    this.$state.current.name !== 'home.register' &&
                    this.$state.current.name !== 'home.knowUs' &&
                    this.$state.current.name !== 'home.contact'
                    // this.$state.current.name !== 'home.faq' &&
                    // this.$state.current.name !== '/policies' &&
                    // this.$state.current.name !== '/cookies' &&
                    // this.$state.current.name !== '/contactcenter_home'
                    && this.ngAuthSettings.site.config.redirectToB2bPage) {
                    this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
                }
            }
        })
        // this.redirect();
        this.getParams();
        this.appendToElement = window.document.querySelector('#formulario-busqueda-header');
        this.cookiesAccepted = this.SessionService.get("enabledCookies");
        this.getCurrentTime();

        let Venedor = {
            init: function () {
                if (!this.initialised) {
                    this.initialised = true;
                }
                else {
                    return;
                }
                // Call Venedor Functions
                this.menuHover();
                this.responsiveMenu();
            },
            getNavContainerHeight: function () {
                /* Get nav container Height for better fixed menu */
                if ($(window).width() > 768) {
                    this.navContainerHeight = $('#main-nav-container').outerHeight();
                }
            },
            menuHover: function () {
                // Sub menu show/hide with hoverIntent plugin
                if ($.fn.hoverIntent) {
                    $('ul.menu').hoverIntent({
                        over: function () {
                            if ($(window).width() > 768) {
                                $(this).addClass('active').children('ul, .mega-menu').fadeIn(200);
                            }
                            else {
                                return false;
                            }

                        },
                        out: function () {
                            if ($(window).width() > 768) {
                                $(this).removeClass('active').children('ul, .mega-menu').fadeOut(75);
                            }
                            else {
                                return false;
                            }
                        },
                        selector: 'li',
                        timeout: 145,
                        interval: 55
                    });
                }
            },
            responsiveMenu: function () {
                let menu = $('.menu').clone(false).removeClass('menu').addClass('responsive-nav container'),
                    container = $('#responsive-nav');
                container.append(menu);
                container.find('li, .col-2, .col-3, .col-4, .col-5').each(function () {
                    let $this = $(this);
                    if ($this.hasClass('mega-menu-container')) {
                        $this.removeClass('mega-menu-container');
                    }
                    $this.has('ul, .megamenu').prepend('<span class="menu-button"></span>');
                });
                $('span.menu-button').on('click', function () {
                    let $this = $(this);
                    if (!$this.hasClass('active')) {
                        $(this)
                            .addClass('active')
                            .siblings('ul, .mega-menu')
                            .slideDown('800');
                    }
                    else {
                        $(this)
                            .removeClass('active')
                            .siblings('ul, .mega-menu')
                            .slideUp('800');
                    }
                });
                $("#responsive-nav").on('click', 'a', function () {
                    $("ul.responsive-nav").slideToggle();
                });
                $('#responsive-nav-button').on('click', function () {
                    let $this = $(this);
                    if ($this.hasClass('active')) {
                        $('#responsive-nav').find('.responsive-nav').slideUp(300, function () {
                            $this.removeClass('active');
                        });
                    }
                    else {
                        $('#responsive-nav').find('.responsive-nav').slideDown(300, function () {
                            $this.addClass('active');
                        });
                    }
                });
            },
        };
        Venedor.init();
        this.$timeout(function () {
            $('#iconthird, #iconthird-user').on('click', function () {
                $('#slthird').slideToggle('fast');
            });
        }, 500);


    }

    getOfflinePage() {

        const second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
        let now = new Date().getTime();

        let fecha = new Date();
        fecha.setHours(fecha.getHours() + 5);
        fecha = fecha.toISOString();
        var fecha_date = fecha.split('T');
        var fecha_time = fecha_date[1].split('.');
        var fecha_time = fecha_date[1].split(':');
        fecha_date = fecha_date[0];

        let countDown = fecha_date + ' ' + fecha_time[0] + ':' + fecha_time[1];

        try {
            countDown = new Date(this.params.offlineTime).getTime();
        } catch (error) {
        }

        let distance = countDown - now;

        if (distance < 0) {
            return;
        }

        this.$interval(() => {
            now = new Date().getTime();
            distance = countDown - now;

            this.days = Math.floor(distance / (day));
            this.hour = Math.floor((distance % (day)) / (hour));
            this.minute = Math.floor((distance % (hour)) / (minute));
            this.second = Math.floor((distance % (minute)) / second);

        }, second);
    }
    scrollToTop(scrollDuration) {
        console.log("scroll");
    }
    logout() {
        this.LoginService.logout().then(response => {
            if (this.cart.cartId) {
                let data = {
                    'cartId': this.cart.cartId
                };

                this.globals = {};
                this.cart = {};
                this.SessionService.remove('globals');
                this.SessionService.remove('cartId');
                this.SessionService.remove('tunnelPayMethod');
                this.SessionService.remove('tunnelCity');
                // if(this.$state.current.name !== 'home.home'){
                this.$rootScope.reloadProyect = true;
                this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                // } else {
                //
                // }
                this.$state.reload();
                // this.CartService.clearCart(data).then(response => {
                //     this.globals = {};
                //     this.cart = {};
                //     this.SessionService.remove('globals');
                //     this.SessionService.remove('cartId');
                //     // if(this.$state.current.name !== 'home.home'){
                //     this.$rootScope.reloadProyect = true;
                //     this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                //     // } else {
                //     //
                //     // }
                //     this.$state.reload();
                // }).catch(reason => {

                // });
            } else {
                this.globals = {};
                this.cart = {};
                this.SessionService.remove('globals');
                this.SessionService.remove('cartId');
                this.$rootScope.reloadProyect = true;
                this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                this.$state.reload();
            }

        })
    }

    getCurrentTime() {
        this.currentTime = new Date().getSeconds();
    };

    setWidgetId(widgetId) {
        this.captchaId = widgetId;
    };

    setResponse(response) {
        this.enteredCaptcha = true;
        this.expiredCaptcha = false;

        this.captcha = response;
    };

    cbExpiration() {
        this.expiredCaptcha = true;
        this.enteredCaptcha = false;

        this.captcha = '';
    };

    redirect() {
        // /**
        //  * Redirect to the b2b page if the b2b site flag is enabled and
        //  * there is no user logged.
        //  */
        // if(this.ngAuthSettings.site.config.redirectToB2bPage) {
        //   // let urlB2b = this.ngAuthSettings.site.app.url + 'introB2b.html';
        //   if(
        //     this.$state.current.name !== 'home.login' &&
        //     this.$state.current.name !== 'home.register' &&
        //     this.$state.current.name !== 'home.knowUs' &&
        //     this.$state.current.name !== 'home.contact'
        //     // this.$state.current.name !== 'home.faq' &&
        //     // this.$state.current.name !== '/policies' &&
        //     // this.$state.current.name !== '/cookies' &&
        //     // this.$state.current.name !== '/contactcenter_home'
        //   )
        //   {
        //     try {
        //       if(!this.globals.currentUser.userId)  this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
        //     }
        //     catch(e) { this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session); }
        //   }
        //   else {
        //     try {
        //       if(this.$state.current.name === 'home.contactcenter_home' && !this.globals.currentUser.userId) {
        //         this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
        //       }
        //     }
        //     catch(e) {
        //       this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
        //     }
        //   }
        // }
        //
        // /**
        //  * ===================================================================================================
        //  * Redirect to the home page if the user is logged
        //  * ===================================================================================================
        //  */
        // if(this.$state.current.name === 'home.login') {
        //   try {
        //     if(this.globals.currentUser.userId) {
        //       this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
        //     }
        //   }
        //   catch(e) {}
        // }else if(this.$state.current.name === 'home.orders'){
        //   try {
        //     if(!this.globals.currentUser.userId) {
        //       this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
        //     }
        //   }
        //   catch(e) {
        //     this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
        //   }
        // }
    }

    updateCartInfo(arg) {

        this.SessionService.getGlobals().then(globals => {
            let cartId = this.SessionService.get('cartId') || '';
            let userId = globals.currentUser.userId;

            this.CartService.getCartResumeData(cartId, userId).then(response => {
                this.cart = response;
            });

            if (arg === 'modalResponseItems') {
                this.SessionService.loadCartInfo(this.cart, 'put');
            }
        })
    }

    getParams() {
        this.globalParams = this.params;
        // Init google analytics
      try{
        if (this.params.uaCode) {
            this.$window.ga('create', this.params.uaCode, 'auto');
            this.$window.ga('create', this.params.uaCodeES, 'auto');
            this.$window.ga('send', 'pageview', { page: this.$location.url() });
        }
      } catch (e) {

      }
        // Operating center selected


         // En b2b no se muestra este modal
        /* if (this.globalParams.showLocationQuestion) {


            if (!this.userData.cartInfo.cartLocation || (this.userData.cartInfo.cartLocation && !this.userData.cartInfo.cartLocation.cityId)) {

                 this.showModalLocations();
            }

        }*/
        /*if (!this.globalParams.operatingCenterSelected) {

          let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
              modalOptions: () => options
            }
          });
        }*/
        // items list view
        try {
            let pcView = this.globalParams.itemsView.pc;
            let tabletView = this.globalParams.itemsView.tablet;
            let mobileView = this.globalParams.itemsView.mobile;

            // var cookieItemView = SessionService.get('itemsView') || '';

            if ($(window).width() >= 1200) {
                vistaMultipleProductos = '.btn-vista' + '3' + ' a';
                this.SessionService.set('itemsView', pcView);
            }

            // TABLET
            else if ($(window).width() >= 767 && $(window).width() < 1200) {
                vistaMultipleProductos = '.btn-vista' + '3' + ' a';
                this.SessionService.set('itemsView', tabletView);
            }

            // MOBILE
            else if ($(window).width() < 767) {
                vistaMultipleProductos = '.btn-vista' + '3' + ' a';
                this.SessionService.set('itemsView', mobileView);
            }

        }
        catch (e) {
        }
    }

    showModalLocations() {
        return this.SharedService.getLocations().then(response => {
            let options = {
                title: this.globalParams.titleLocationQuestion,
                titleSecond: this.globalParams.titleLocationQuestionSecond,
                isHtml: true,
                titleIsHtml: true,
                content: this.globalParams.descripcionLocationQuestion,
                contentSecond: this.globalParams.descripcionLocationQuestionSecond,
                showBottonCancel: false,
                textActionCancel: 'Cancelar',
                locationSelected: this.userData.cartInfo.cartLocation,
                locations: response.data,
                textAction: 'Aceptar'
            };
            let modalInstance = this.$uibModal.open({
                animation: true,
                template: modalLocation,
                backdrop: 'static',
                keyboard: false,
                controller: 'ModalLocationController',
                controllerAs: 'mdCtrl',
                size: '',
                resolve: {
                    modalOptions: () => options
                }
            });
        }).catch(error => {
            console.log(error);
        });
    }

    isClientB2B() {
        this.isUserB2B = false;
        // Client
        try {
            this.isUserB2B = (this.globals.currentClient.id && this.globals.currentClient.third.isB2B) ||
                (!this.globals.currentClient.id && this.globals.currentUser.userId && this.globals.currentUser.isB2B);
        }
        catch (e) {
        }
        // User
        try {
            this.isUserB2B = this.globals.currentUser.userId && this.globals.currentUser.isB2B;
        }
        catch (e) {
        }
        return this.isUserB2B;
    }

    sendNewsletterForm(form) {
        if (form.$valid) {
            this.sendingNewsletterInfo = true;
            this.newsletterInfoError = false;
            this.newsletterInfoMessage = '';
            this.SharedService.sendNewsletterForm(this.newsletterDataForm).then(response => {
                $scope.sendingNewsletterInfo = false;
                $scope.newsLetterInfoSent = true;
                $scope.newsletterInfoMessage = response.message;

                if (response.error) {
                    $scope.newsletterInfoError = true;
                }
            }).catch(error => {
                $scope.sendingNewsletterInfo = false;
                $scope.newsletterInfoError = true;
                $scope.newsletterInfoMessage = response.message;
            });
        }
        else {
            angular.forEach(form.$error.required, function (field) {
                field.$setDirty();
            });
        }
    }

    removeClientSelected() {
        this.globals.currentUser.userId = this.globals.currentUser.sellerId;
        this.globals.currentClient = {};
        // Clear cart
        if (this.cart.cartId) {
            let data = {
                'cartId': this.cart.cartId
            };
            this.CartService.clearCart(data).then(response => {
                this.cart = {};
                this.SessionService.put('cartId', '');
                this.SessionService.put('globals', this.globals);
                this.sellerQuoteFormDataHeader = {};
                this.$state.reload();
            });
        } else {
            this.cart = {};
            this.SessionService.put('cartId', '');
            this.SessionService.put('globals', this.globals);
            this.sellerQuoteFormDataHeader = {};
            this.$state.reload();
        }
        // $location.path('/contactcenter_home');
    }

    removeItemFromCart(product) {
        let options = {
            title: `ELIMINAR PRODUCTO <b>${product.name}</b>`,
            isHtml: true,
            titleIsHtml: true,
            content: `�En realidad desea eliminar del carrito el producto <b>${product.name}</b>?`,
            showBottonCancel: true,
            textActionCancel: 'Cancelar',
            textAction: 'Aceptar'
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            this.confirmRemoveItem(product.id, product);
        }).catch(() => {

        });

    }

    showModalSelectBranchUserB2B() {

        let options = {
            userData: this.globals,
            branches: this.globals.currentUser.operatingCenters,
            currentBranch: this.globals.currentClient.operatingCenter,
            cmsMessage: this.globalParams.cmsInfo
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            static: true,
            template: modalSelectBranch,
            controller: 'ModalSelectBranchController',
            controllerAs: 'mdCtrl',
            size: 'lg',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(result => {
            //console.log(result);
            this.globals = angular.copy(result);
        }).catch(reason => {

        });
    }

    showModalCartSellerHeader() {
        let options = {
            globals: this.globals
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalSelectClient,
            controller: 'ModalSelectClientController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then((globals) => {
            this.globals = angular.copy(globals);
            this.LoginService.setOperatingCenter(data.operatingCenter.id).then(response => {
                if (!response.error) {
                    this.SessionService.put('globals', this.globals);
                    // Clear cart
                    if (this.cart.cartId) {
                        let data = {
                            'cartId': this.cart.cartId
                        };
                        this.CartService.clearCart(data).then(response => {
                            this.cart = {};
                            this.SessionService.put('cartId', '');
                            this.$state.go('home.salesHome');
                            this.$timeout(() => {
                                this.$state.reload()
                            }, 2000);
                        });
                    } else {
                        this.cart = {};
                        this.SessionService.put('cartId', '');
                        this.$state.go('home.salesHome');
                        this.$timeout(() => {
                            this.$state.reload()
                        }, 2000);
                    }
                    // window.location.href = config.env.basePath + '#/reportes/b2b/dashboard';
                    // window.location.reload();
                }
                else {
                    alert('Ha ocurrido un error al establecer el centro de operacion');
                    this.$state.reload();
                }
            }).catch(reason => {
                alert('Ha ocurrido un error al establecer el centro de operacion');
                this.$state.reload();
            });
        }).catch(reason => {

        });
    }

    showModalFormPQRS() {
        let options = {
            globals: this.globals
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            static: true,
            template: createPQRSModal,
            keyboard: false,
            controller: 'PqrsFormModalController',
            controllerAs: 'mdCtrl',
            size: 'lg',
            resolve: {
                modalOptions: () => options
            }
        });
    }

    confirmRemoveItem(productId, product) {
        let cartId = this.SessionService.get('cartId') || '';
        if (cartId) {
            this.deletingItemCart = true;
            this.deletedItemCart = false;
            this.errorDeletedItemCart = false;
            this.CartService.deleteItemFromCart(productId, cartId).then(response => {
                this.deletingItemCart = false;
                if (!response.error) {
                    if (!response.pesoMinimoValidoBodega) {
                        this.updateCartInfo();
                        this.asignarSucursalPrincipalEliminarItem(this.cart.cartId, product)
                    } else {
                        this.deletedItemCart = true;
                        this.updateCartInfo();
                        this.$rootScope.$emit('onUpdateCart');
                        let options = {
                            title: 'Notificaci�n',
                            isHtml: true,
                            content: `<div class="alert alert-success" style="margin-bottom: 10px;">
              El producto <b>${product ? product.name : ''}</b> ha sido eliminado del carrito.
            </div>`,
                            size: 'sm',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }
                }
                else {
                    this.errorDeletedItemCart = true;
                }
            }).catch(error => {
                this.deletingItemCart = false;
                this.deletedItemCart = false;
                this.errorDeletedItemCart = true;
            });
        }
    }


    /**
     * =======================================================================================================================
     * Init the socekts to preload the client info.
     * =======================================================================================================================
     */
    initSocket() {
        try {
            let isLogged = this.globals.currentUser.isLogged;
            let isSeller = this.globals.currentUser.isSeller;
            let sellerExt = this.globals.currentUser.sellerExt;

            // if(isLogged && isSeller) {
            //   var socket = io('http://98.142.108.42:3000');

            //   socket.on('preload client', function(msg){
            //     var data = JSON.parse(msg);

            //     if(sellerExt === +data.seller.ext) {
            //       $('#modalQuoteSellerHeader #sellerQuoteAttendantDocumentNumberHeader').val(data.client.nid);
            //       $scope.sellerQuoteFormDataHeader.attendant.documentNumber = data.client.nid;
            //       $scope.showModalCartSellerHeader();

            //       document.getElementById('newClientNotificacion').play();
            //       alert('Un nuevo cliente se encuentra en espera de ser atendido');
            //     }
            //   });
            // }
        }
        catch (e) {
        }
    }

    countWatchers() {
        let root = angular.element(document.getElementsByTagName('body'));
        let watchers = [];
        let f = (element) => {
            angular.forEach(['$scope', '$isolateScope'], scopeProperty => {
                if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
                    angular.forEach(element.data()[scopeProperty].$$watchers, watcher => {
                        watchers.push(watcher);
                    });
                }
            });

            angular.forEach(element.children(), childElement => {
                f(angular.element(childElement));
            });
        };

        f(root);

        // Remove duplicate watchers
        let watchersWithoutDuplicates = [];
        angular.forEach(watchers, item => {
            if (watchersWithoutDuplicates.indexOf(item) < 0) {
                watchersWithoutDuplicates.push(item);
            }
        });

        this.resultWatchers = watchersWithoutDuplicates.length;
    }


    enableCookies() {
        this.cookiesAccepted = true;
        this.SessionService.put("enabledCookies", true);
    };

    getSearchProductsGlobal(searchText) {
        let userId = '';
        let cartId = '';
        try {
            userId = this.globals.currentUser.userId;
            cartId = this.cart.cartId;
        }
        catch (e) {
        }
        this.offsetProductSearch = 0;
        return this.SharedService.getSearchProductsGlobal(searchText, 10, userId, cartId).then(response => {
            return response;
        }).catch(error => {
            console.log(error);
            return null;
        });
    };

    goToProduct($item, $isProcedure) {

        this.typeaheadIsOpen = false;

        if ($item && $isProcedure) {
            this.$state.go('home.procedureDetailSlug', { procedureSlug: $item });
        } else if ($item) {
            this.$state.go('home.productDetailSlug', { productSlug: $item });
        }
    }

    goToSearchProduct($item) {
        this.search = false;
        this.typeaheadIsOpen = false;
        $item = $item || this.globalSearchTextHome;
        // if($scope.globalSearchTextHome) {
        if ($item) {
            let searchText = encodeURIComponent($item);
            this.$state.go('home.productSearch', { searchText: searchText });
        }
    }

    toggleSearch() {
        this.search = !this.search;
    }



    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    getCart() {
        return this.cart;
    }

    asignarSucursalPrincipalEliminarItem(cartId,product){

        let idCiudad = this.globals.currentClient.operatingCenter.ciudad_id;
        let idUsuario = this.globals.currentUser.userId;
        let data = {
          'userId': idUsuario,
          'ciudadId': idCiudad
        };
        this.CartService.getPrincipalBranchOffice(data).then(response => {
          let idSucursalSecundaria = response.listaSucursales[0].id;
          if (idSucursalSecundaria != null) {
            this.setSucursalPrincipalEliminarItem(idSucursalSecundaria, idUsuario, product);
          }
        });
        this.CartService.updateDateCart(cartId).then(response => {
          return response;
        });
    }

    setSucursalPrincipalEliminarItem(idSucursal, userId, product) {

        let mensajeCambioSucursal = '';
        let mensajeModalidad = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;

            allMessage.push(mensajeCambioSucursal);
            if (mensajeModalidad != '') {
                allMessage.push(mensajeModalidad);
            }
        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.userData.globals.currentClient.operatingCenter = response.branch;
                    this.userData.globals.currentClient.seller = response.seller;

                    this.$rootScope.$broadcast('actualizarHeader', response.branch);
                    this.actualizarCondicionesPagoCambioSucursal();
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.cart.cartId }).then(response => {
                        if (!response.error) {
                            // verificar si se tiene tipo de modalidad
                            this.CartService.getShippingMode(this.cart.cartId).then(response => {
                                if (response.modalidad) {
                                    let tipoModalidad = response.modalidad.tipo_modalidad;
                                    // Si la modalidad es recoge
                                    if (tipoModalidad == 0) {
                                        mensajeModalidad = this.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
                                        allMessage.push(mensajeModalidad);
                                        let currentClient = this.SessionService.get('currentClient');
                                        let sucursalId = currentClient.operatingCenter.id;

                                        this.CartService.verifyBranchLock(sucursalId).then(response => {
                                            if (!response.error) {
                                                if (response.bloqueoSucursal) {
                                                    this.modalidadRecoge = false;
                                                    let messageBloqueoRetiro = this.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO
                                                    allMessage.push(messageBloqueoRetiro);
                                                    this.showModalAllMessageDeleteItem(allMessage, product);
                                                } else {
                                                    this.showModalAllMessageDeleteItem(allMessage, product);
                                                }
                                            }
                                        });
                                    }
                                    // Si la modalidad es entrega
                                    else {
                                        mensajeModalidad = this.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
                                        allMessage.push(mensajeModalidad);
                                        if (allMessage !== null) {
                                            this.showModalAllMessageDeleteItem(allMessage, product);
                                        }
                                        this.getPromesaEntrega();
                                        this.$rootScope.$broadcast('onUpdateDescargue');
                                    }
                                } else {
                                    if (allMessage !== null) {
                                        this.showModalAllMessageDeleteItem(allMessage, product);
                                    }
                                }
                            });
                        }
                    });
                } catch (e) {
                }

            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    showModalAllMessageDeleteItem(allMesagge,product) {
        let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

        for (let i = 0; i < allMesagge.length; i++) {
          contentDynamic += `
                                <ul><li>` + allMesagge[i] + `</li></ul>`;
        }

        if (contentDynamic != '') {
          let optionsMessage = {
            title: 'Actualización de precios',
            isHtml: true,
            content: contentDynamic,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar',
            backdrop: 'static'
          };

          let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: 'md',
            backdrop: 'static',
            resolve: {
              modalOptions: () => optionsMessage
            }
          });
          modalInstance.result.then(() => {
            if (__env.adaptative) {
              this.messageMaterial('El producto' + product.name + ' ha sido eliminado del carrito.')
            } else {
              let options = {
                title: 'Notificación',
                isHtml: true,
                content: `<div class="alert alert-success" style="margin-bottom: 10px;">
                El producto <b>${product ? product.name : ''}</b> ha sido eliminado del carrito.
              </div>`,
                size: 'sm',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              this.messageResponse(options);
            }
          }).catch(() => {

          });
        }
      }

      getPromesaEntrega() {
        let cartId = this.cart.cartId;

        if (cartId != null) {
          this.CartService.getDeliveryPromise(cartId).then(response => {
            if (!response.error) {
                this.$rootScope.$broadcast('onUpdatePromise', response.data.promesa_entrega_dias);
            }
          });
        }
      }

      actualizarCondicionesPagoCambioSucursal(){
        let cartId = this.cart.cartId;
        let userId = this.globals.currentUser.userId;
        let data = null;
        this.CartService.getPayConditionsChangeBranchOffice(userId, cartId).then(response => {
          let payConditions = response;
          // Asignamos la primera forma de pago
          if(payConditions.length > 0){
             data = {
                'cartId': this.cart.cartId,
                'payConditionId': payConditions[0].id
              };
          }else{
            data = {
                'cartId': this.cart.cartId,
                'payConditionId': payConditions.id
            };
          }
          this.CartService.updatePayCondition(data).then(response => {
            if (response.error) {
                console.log('Ocurrio un error al momento de actualizar la condicion')
            }
          });
    
          
          //this.orderDataForm.payCondition = response[0].id;
        }).catch(reason => {
    
        });
      }
}

SharedController.$inject = inject;

export default SharedController;



/** WEBPACK FOOTER **
 ** ./www/components/shared/shared.controller.js
 **/